import { render, staticRenderFns } from "./ProgramMetricCategoryInput.vue?vue&type=template&id=2886e112&scoped=true&lang=pug&"
import script from "./ProgramMetricCategoryInput.vue?vue&type=script&lang=js&"
export * from "./ProgramMetricCategoryInput.vue?vue&type=script&lang=js&"
import style0 from "./ProgramMetricCategoryInput.vue?vue&type=style&index=0&id=2886e112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886e112",
  null
  
)

export default component.exports